import { Component, OnInit } from '@angular/core';
import { TreeNode } from 'primeng/api';
import * as Permission from "@common/application/entities/Permission";
import { ApiService } from '@services/api/api.service';
import { NbToastrService } from '@nebular/theme';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-permission-list',
  templateUrl: './permission-list.component.html',
  styleUrls: ['./permission-list.component.css']
})
export class PermissionListComponent implements OnInit {
  _permissions: TreeNode[];
  permissionsUpdatedObserver: Subject<any> = new Subject<any>();
  public get entityId() { return this._entityId };
  public set entityId(value) {
    if (this._entityId == value)
      return;
    this.roleId = value; this.loadData();
  }
  public parent: any;

  protected _entityId: any;
  get permissions() {
    return this._permissions;
  }
  set permissions(value) {
    this._permissions = value;
  }
  selectedPermissions: any ;
  roleId: any; differ: any;
  loading: boolean = false;
  endPoints: Permission.RolePermissionEndPoints = new Permission.RolePermissionEndPoints();
  constructor(private apiService: ApiService, private messageService: NbToastrService, private route: ActivatedRoute) {
  }

  ngOnInit() {
    

    if (this.parent && this.parent.entityIdChange) {
      this.entityId = this.parent.entityId;
      this.parent.entityIdChange.subscribe(entityId => {
        this.entityId = entityId;
      })
    }
    else {
      this.route.params.subscribe(params => {
        if (params.id) {
          this.roleId = params.id;
          this.loadData();
        }
      })
    }
  }

  loadData() {
    this.loading = true;
    this.selectedPermissions = new Array();
    this.apiService.get(this.endPoints.list.url, { params: { roleId: this.roleId } })
      .subscribe(items => {
        this.loading = false;

        this.permissions = new Array<TreeNode>();
        
        items.filter(o => !o.parentId).forEach(o => {
          this.permissions.push(this.populateChildren(o, items))
        });
        this.permissionsUpdatedObserver.next(this.getSelectedPermissionIds());
      }, err => {
        this.loading = false;
      })
      ;
  }

  private getSelectedPermissionIds() {
    return this.selectedPermissions.map(o => {
      return o.data.id
    });
  }

  populateChildren(item, items) {
    let treeNode: TreeNode = {
      data: item,
      label: item.name,
      children: new Array<TreeNode>(),
      expanded : true
    }
    items.filter(o => o.parentId == item.id).forEach(o => {
      treeNode.children.push(this.populateChildren(o, items))
    })
    if (item.selected)
      this.selectedPermissions.push(treeNode);
    return treeNode;
  }

  setPermissions() {
    var permissionIds = this.getSelectedPermissionIds();
    this.apiService.post('/api/role/setPermissions', {
      roleId: this.roleId,
      permissions: permissionIds
    }).subscribe(o => {
      this.permissionsUpdatedObserver.next(permissionIds);
      }, err => {

      })
  }

  onNodeSelect(event) {
    this.setPermissions();
  }

  onNodeUnselect(event) {
    this.setPermissions();
  }

}
